(()=>{
  const d=document;
  const idle=window.requestIdleCallback?cb=>window.requestIdleCallback(cb,{timeout:800}):cb=>setTimeout(cb,160);
  const money=(cents,currency)=>{try{return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:currency||'EUR'}).format((Number(cents)||0)/100)}catch(_){return ((Number(cents)||0)/100).toFixed(2)+' €'}};
  const pad=n=>String(n).padStart(2,'0');

  function initTimer(el){
    if(!el||el.dataset.lhTimerReady)return;
    el.dataset.lhTimerReady='1';
    const end=Date.parse(el.dataset.end||'');
    if(Number.isNaN(end))return;
    const days=el.querySelector('[data-days]'),hours=el.querySelector('[data-hours]'),mins=el.querySelector('[data-mins]'),secs=el.querySelector('[data-secs]'),label=el.querySelector('[data-timer-status]');
    let timer=null;
    const tick=()=>{
      let diff=end-Date.now();
      if(diff<=0){diff=0;el.classList.add('is-ended');if(label)label.textContent='OFFRE TERMINÉE';if(timer){clearInterval(timer);timer=null}}
      const day=Math.floor(diff/86400000),hour=Math.floor(diff%86400000/3600000),min=Math.floor(diff%3600000/60000),sec=Math.floor(diff%60000/1000);
      if(days)days.textContent=pad(day);if(hours)hours.textContent=pad(hour);if(mins)mins.textContent=pad(min);if(secs)secs.textContent=pad(sec);
    };
    tick();if(end>Date.now())timer=setInterval(tick,1000);
  }

  function initMain(root){
    if(!root||root.dataset.lhV11Ready)return;
    root.dataset.lhV11Ready='1';

    const main=root.querySelector('[data-lh-main-image]');
    const thumbs=[...root.querySelectorAll('[data-lh-thumb]')];
    let index=Math.max(0,thumbs.findIndex(x=>x.classList.contains('is-active'))),startX=null;
    const warm=btn=>{
      if(!btn||btn.dataset.preloaded==='1')return;
      btn.dataset.preloaded='1';
      const img=new Image();img.decoding='async';img.sizes='(max-width: 800px) calc(100vw - 20px), (max-width: 1200px) 56vw, 680px';
      if(btn.dataset.srcset)img.srcset=btn.dataset.srcset;if(btn.dataset.src)img.src=btn.dataset.src;
    };
    const show=i=>{
      if(!main||!thumbs.length)return;
      index=(i+thumbs.length)%thumbs.length;
      const btn=thumbs[index];
      if(btn.dataset.srcset)main.srcset=btn.dataset.srcset;else main.removeAttribute('srcset');
      main.sizes='(max-width: 800px) calc(100vw - 20px), (max-width: 1200px) 56vw, 680px';
      if(btn.dataset.src)main.src=btn.dataset.src;
      main.alt=btn.dataset.alt||main.alt;
      thumbs.forEach((x,n)=>{x.classList.toggle('is-active',n===index);x.setAttribute('aria-pressed',n===index?'true':'false')});
      idle(()=>warm(thumbs[(index+1)%thumbs.length]));
    };
    thumbs.forEach((btn,i)=>{btn.addEventListener('click',()=>show(i));btn.addEventListener('pointerenter',()=>warm(btn),{once:true});btn.addEventListener('focus',()=>warm(btn),{once:true})});
    root.querySelector('[data-lh-gallery-prev]')?.addEventListener('click',()=>show(index-1));
    root.querySelector('[data-lh-gallery-next]')?.addEventListener('click',()=>show(index+1));
    const media=root.querySelector('[data-lh-main-media]');
    media?.addEventListener('touchstart',e=>{startX=e.touches[0]?.clientX??null},{passive:true});
    media?.addEventListener('touchend',e=>{if(startX===null)return;const x=e.changedTouches[0]?.clientX??startX,dx=x-startX;if(Math.abs(dx)>38)show(index+(dx<0?1:-1));startX=null},{passive:true});
    if(thumbs[1])idle(()=>warm(thumbs[1]));

    const data=root.querySelector('[data-lh-variants-json]');
    let variants=[];try{variants=JSON.parse(data?.textContent||'[]')}catch(_){variants=[]}
    const currency=root.dataset.currency||'EUR',input=root.querySelector('[data-lh-variant-input]'),price=root.querySelector('[data-lh-price]'),compare=root.querySelector('[data-lh-compare]'),buy=root.querySelector('[data-lh-buy]'),stock=root.querySelector('[data-lh-stock]'),groups=[...root.querySelectorAll('[data-lh-option-group]')];
    const productTitle=(root.querySelector('h1')?.textContent||'').trim();
    const selected=()=>groups.map(g=>g.querySelector('.lh-option-btn.is-active')?.dataset.optionValue||'');
    const exact=()=>{
      if(!groups.length){const current=String(input?.value||'');return variants.find(v=>String(v.id)===current)||variants.find(v=>v.available)||variants[0]||null}
      const s=selected();return variants.find(v=>(v.options||[]).every((o,i)=>String(o)===String(s[i])))||null;
    };
    const payload=v=>({priceCents:Number(v?.price||0),title:productTitle,image:main?.currentSrc||main?.src||'',variantId:v?.id||'',quantity:1});
    const externalUrl=v=>window.LashiExternalCheckout?.buildUrl?.(payload(v))||'';
    const refreshAvailability=()=>{
      if(!groups.length)return;
      const s=selected();
      groups.forEach((g,idx)=>g.querySelectorAll('.lh-option-btn').forEach(btn=>{
        const candidate=s.slice();candidate[idx]=btn.dataset.optionValue;
        const possible=variants.some(v=>v.available&&(v.options||[]).every((o,i)=>i===idx?String(o)===String(candidate[i]):(!candidate[i]||String(o)===String(candidate[i]))));
        btn.classList.toggle('is-unavailable',!possible);btn.setAttribute('aria-disabled',possible?'false':'true');
      }));
    };
    const setBuy=v=>{
      if(!buy)return;
      const url=v?.available?externalUrl(v):'';
      if(v?.available&&url){buy.removeAttribute('aria-disabled');buy.removeAttribute('tabindex');buy.href=url;buy.textContent='ACHETER MAINTENANT'}
      else{buy.setAttribute('aria-disabled','true');buy.setAttribute('tabindex','-1');buy.href='#';buy.textContent=v?.available?'OFFRE INDISPONIBLE':(v?'ÉPUISÉ':'OPTION INDISPONIBLE')}
    };
    const sync=()=>{
      const v=exact();refreshAvailability();setBuy(v);
      if(!v){if(stock){stock.textContent='Combinaison indisponible';stock.classList.add('is-out')}return}
      if(input)input.value=String(v.id);
      if(price)price.textContent=money(v.price,currency);
      if(compare)compare.textContent=v.compare_at_price&&Number(v.compare_at_price)>Number(v.price)?money(v.compare_at_price,currency):'';
      if(stock){stock.textContent=v.available?'En stock — expédition rapide':'Actuellement indisponible';stock.classList.toggle('is-out',!v.available)}
      try{const u=new URL(location.href);u.searchParams.set('variant',String(v.id));history.replaceState({},'',u)}catch(_){}
    };
    groups.forEach(g=>g.querySelectorAll('.lh-option-btn').forEach(btn=>btn.addEventListener('click',()=>{if(btn.getAttribute('aria-disabled')==='true')return;g.querySelectorAll('.lh-option-btn').forEach(x=>{x.classList.remove('is-active');x.setAttribute('aria-pressed','false')});btn.classList.add('is-active');btn.setAttribute('aria-pressed','true');sync()})));
    buy?.addEventListener('click',e=>{
      if(buy.getAttribute('aria-disabled')==='true'){e.preventDefault();return}
      const v=exact();
      if(v?.available&&window.LashiExternalCheckout?.redirect){e.preventDefault();window.LashiExternalCheckout.redirect(payload(v),buy)}
    });
    sync();
    root.querySelectorAll('[data-lh-promo-timer]').forEach(initTimer);
  }

  const boot=scope=>{
    if(scope?.matches?.('[data-lh-pdp-main]'))initMain(scope);
    scope?.querySelectorAll?.('[data-lh-pdp-main]').forEach(initMain);
    scope?.querySelectorAll?.('[data-lh-promo-timer]').forEach(initTimer);
  };
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',()=>boot(d),{once:true});else boot(d);
  d.addEventListener('shopify:section:load',e=>boot(e.target||d));
})();
